import { ProductService } from 'src/app/services/product.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/services/shared.service';
import { AccountService } from 'src/app/services/account.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserDetailResult, Product } from 'src/app/model/UserDetail';
import { UserModel } from 'src/app/model/UserModel';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { environment } from 'src/environments/environment';
import { DataUnitofMeasureInfo } from 'src/app/model/selfcareproducts';

@Component({
  selector: 'app-requestloan',
  templateUrl: './requestloan.component.html',
  styleUrls: ['./requestloan.component.css']
})
export class RequestloanComponent implements OnInit {

  processing: boolean = false;
  tranSuccess: boolean = false;
  tranFailed: boolean = false;
  userdetail: UserDetailResult;
  customerBalance: number;
  mdn: string;
  i_account: number;
  i_customer: number;
  amount: number;
  currentProduct: Product;
  currentPlan: string;
  remainingVolume: string;
  loanCount: number;
  currentUser: UserModel;
  period: any[];
  selectedPeriod: number = 0
  remainingVolumeForLoanCalc: string;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService, private sharedService: SharedService, private accountService: AccountService, private paymentService: PaymentService, private authenticationService: AuthenticationService, private productService: ProductService) { }

  async ngOnInit() {

    const acc: number = parseInt(this.activatedRoute.snapshot.queryParamMap.get('acc'));
    this.currentUser = this.authenticationService.getCurrentUser();

    if (!acc || !this.currentUser) {
      this.toastr.error("Error getting service plan details", "Error");
      this.router.navigateByUrl('/dashboard');
      return;
    }
    this.period = this.getdays();
    await this.getRenewalObject(acc);
  }

  UserIsAuthourised(i_account : string, i_customer:string){
    //deny unauthourised individual accounts
    if(this.currentUser.i_Account != "0"){

      if(this.currentUser.i_Account != i_account){
        return false;
      }

    }
    else{

      //deny unauthorised customer accounts
      if(this.currentUser.i_Customer != i_customer){
          return false;
      }

    }
    return true;
  }

  async getRenewalObject(i_account: number) {

    try {
      var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      model.i_account = i_account;
      model.DownloadType = "ACC:GetDetail";
      console.log(this.amount);
      let res = await this.accountService.getAccountDetailFromLteHttp(i_account).toPromise();

      if (!res.Status) {
        this.toastr.error(environment.GenericErrorMsg);
        return;
      }

      let userdetail: UserDetailResult = res.Result;

      if(!userdetail.i_account){
        this.toastr.error(environment.GenericErrorMsg);
        return;
      }

      if(!this.UserIsAuthourised(userdetail.i_account.toString(),userdetail.i_customer.toString())){
        this.toastr.error(environment.GenericErrorMsg);
        return;
      }
  
      let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");
  
      if (voiceproduct) {
        this.toastr.error("loan request is only available on data plans");
        //this.router.navigateByUrl("/dashboard");
        return;
      }

      this.userdetail = userdetail;
      this.i_account = userdetail.i_account;
      this.i_customer = userdetail.i_customer;
      this.mdn = userdetail.ID.toString();
      let productResult = await this.productService.getSingleProductsFromLte(userdetail.Product.i_product).toPromise();
      this.currentProduct = productResult.Result;
      this.currentPlan = `${this.currentProduct.Name}-₦${this.currentProduct.Price.toLocaleString()}`
      this.remainingVolume = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(2) + DataUnitofMeasureInfo[userdetail.Product.Display.DataCapacity.UnitofMeasure];

      this.remainingVolumeForLoanCalc = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(3);
      
      this.loanCount = userdetail.LoanCount ? userdetail.LoanCount : 0;
    }
    catch (err) {
      this.tranFailed = true;
    }

  }

  async Proceed() {

    if(this.userdetail.CustomerClass === 'Enterprise'){
      this.toastr.error("Loan Restricted on Account");
      return;
    }
    try {

      if(!this.userdetail.i_account){
        this.toastr.error(environment.GenericErrorMsg);
        return;
      }

      if (this.selectedPeriod < 1 || this.selectedPeriod > 3) {
        this.toastr.error("Invalid days", "Error");
        return;
      }

      if(this.loanCount >=3){
        this.toastr.error("You can only take maximum of 3 loans","Error");
        return;
      }
      let balcheckagainst=1500;
      if(this.userdetail.Product.i_product==148){
        balcheckagainst=750;}

      if((this.userdetail.Balance>balcheckagainst && this.userdetail.Product.Display.DataCapacity.UnitofMeasure==9)||
      ((Number.parseFloat(this.remainingVolumeForLoanCalc)>0.5)&&this.userdetail.Product.Display.DataCapacity.UnitofMeasure!=9)){
        this.toastr.error("You are not Eligible for loan due to your current Balance","Error");
        return;
      }
      this.processing = true;
      let res = await this.paymentService.LteGiveLoan(this.userdetail.i_customer, this.userdetail.i_account, this.selectedPeriod, environment.OperatorID).toPromise();

      if (!res.Status) {
        this.tranFailed = true;
        this.processing = false;
        return;
      }

      this.tranSuccess = true;
      this.processing = false;
      this.clearform();
      await this.getRenewalObject(this.userdetail.i_account);

    } catch (err) {
      this.tranFailed = true;
      this.processing = false;
    }

  }

  clearform() {
    this.selectedPeriod = 0;
  }

  getdays() {
    return [
      { value: 1, text: "1 day" }, { value: 2, text: "2 days" }, { value: 3, text: "3 days" }
    ]
  }

}
